import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import { useWatch } from "react-hook-form";
import MonitoringReportDirectionOptionsDropdown from "../../../../Utilities/Constants/MonitoringReportDirectionOptionsDropdown";
import MonitoringReportStartEndOptionsDropdown from "../../../../Utilities/Constants/MonitoringReportStartEndOptionsDropdown";
import ValidatedCheckBoxElement from "../../../../Utilities/Forms/ValidatedCheckBoxElement";
import ValidatedSelectElement from "../../../../Utilities/Forms/ValidatedSelectElement";
import DropDownViewModel from "../../../../Utilities/ViewModels/DropDownViewModel";

interface IProps {
    index: number
    baseName: string
    formContext: any
    timeOptions: DropDownViewModel[]
    endTimeOptions: DropDownViewModel[]
    tripRateParamOptions: DropDownViewModel[]
    modeOptions: DropDownViewModel[]
}

export default function TripGeneration({ index, baseName, formContext, timeOptions, endTimeOptions, tripRateParamOptions, modeOptions }: IProps) {

    const enabled = useWatch({
        control: formContext.control,
        name: `${baseName}.enabled`
    });

    const showTimeSelection = useWatch({
        control: formContext.control,
        name: `${baseName}.startEnd`
    });

    return (

        <Grid container size={12}>
            <Grid size={12}>
                <Stack spacing={2}>
                    <ValidatedCheckBoxElement name={`${baseName}.enabled`} label={`Trip Generation ${index}`} />
                    {enabled === true && (
                        <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                            <ValidatedSelectElement name={`${baseName}.startEnd`} label="Start/End Time" options={MonitoringReportStartEndOptionsDropdown} hideClearIcon={true} />
                            {showTimeSelection == "0" &&
                                <>
                                    <ValidatedSelectElement name={`${baseName}.start`} label="Start" options={timeOptions} hideClearIcon={true} />
                                    <ValidatedSelectElement name={`${baseName}.end`} label="End" options={endTimeOptions} hideClearIcon={true} />
                                </>
                            }
                            <ValidatedSelectElement name={`${baseName}.mode`} label="Mode" options={modeOptions} hideClearIcon={true} />
                            <ValidatedSelectElement name={`${baseName}.direction`} label="Direction" options={MonitoringReportDirectionOptionsDropdown} hideClearIcon={true} />
                            <ValidatedSelectElement name={`${baseName}.tripRateParam`} label="Trip Rate Parameter" options={tripRateParamOptions} hideClearIcon={true} />
                        </Stack>
                    )}
                </Stack>
            </Grid>
        </Grid>
    );
}
